import axios from 'axios';

import { CALENDAR } from '../endpoints';

export const getCalendarURL = () => axios.get(CALENDAR);
